module.exports = __webpack_public_path__ + "static/media/mandalorian.dca218e6.svg";